export enum StorageBucketEnum {
  Groups = 'groups',
  Users = 'users',
  Venues = 'venues',
}
